
import { useMemo, useState } from "react";
import { TextField } from "@mui/material";
import MessageSuccess from "../messages/messageSuccess";
import MessageError from "../messages/messageError";
import api from "../services/api";
import Editor from "../ckeditor/editor";
import ButtonLeft from "../utils/buttonLeft";
import InputDocUpload from "../utils/inputFileUpload/inputDocUpload";
import { useSelector } from "react-redux";


const initialRelatorioState = {
    nome: '',
    conteudo: '',
    anexoRelatorio: null,
};

export default function CreateRelatorioEspontaneo({ processoId, modelName, handleClose }) {
    const user = useSelector((state) => state.account.user);
    const [messageSuccess, setMessageSuccess] = useState('')
    const [messageError, setMessageError] = useState('')
    const [relatorio, setRelatorio] = useState(initialRelatorioState)
    const [open, setOpen] = useState(false)

    const selectedFileName = useMemo(() => relatorio?.anexoRelatorio?.name || '', [relatorio?.anexoRelatorio]);
    const canSubmit = Boolean(relatorio?.anexoRelatorio) && !open;

    async function HandleChangeFile(file, name) {
        setMessageError('')
        setRelatorio((prevCadastro) => ({ ...prevCadastro, [name]: file }))
    }


    const sendRelatorio = async () => {
        if (!relatorio?.anexoRelatorio) {
            setMessageError('Anexe um ficheiro PDF antes de salvar o relatório.');
            return;
        }

        if (!user?._id) {
            setMessageError('Não foi possível identificar o utilizador autenticado.');
            return;
        }

        setOpen(true)
        setMessageSuccess('')
        setMessageError('')

        const formData = new FormData();
        formData.append('processoId', processoId);
        formData.append('modelName', modelName?? '');
        formData.append('nome', relatorio?.nome ?? 'sem título');
        formData.append('descricao', relatorio?.conteudo ?? 'sem descrição');
        formData.append('anexo', relatorio?.anexoRelatorio);
        formData.append('userId', user?._id);

        await api.post('/relatorio/create', formData)
            .then(() => {
                setMessageSuccess('Relatório salvo com sucesso')
                setRelatorio(initialRelatorioState)

                setTimeout(() => {
                    handleClose()
                }, 5000);


            }).catch(error => {
                setMessageError(error?.response?.data?.message || 'Não foi possível salvar o relatório no momento.')
            }).finally(() => {
                setOpen(false)
            })
    }

    return (
        <>
            {messageSuccess && <MessageSuccess message={messageSuccess} />}
            {messageError && <MessageError message={messageError} />}

            <div className="tw-space-y-5">
                <section className="tw-rounded-2xl tw-border tw-border-slate-200 tw-bg-white tw-p-4 md:tw-p-5">
                    <h2 className="tw-mb-1 tw-text-xl tw-font-bold tw-text-slate-900">
                        Novo Relatório Espontâneo
                    </h2>
                    <p className="tw-text-sm tw-leading-6 tw-text-slate-600">
                        Preencha o título, descreva o conteúdo do relatório e anexe o documento final em PDF.
                    </p>
                </section>

                <section className="tw-rounded-2xl tw-border tw-border-slate-200 tw-bg-white tw-p-4 md:tw-p-5">
                    <h3 className="tw-mb-4 tw-text-base tw-font-bold tw-text-slate-900">
                        Identificação
                    </h3>

                    <TextField
                        type="text"
                        fullWidth
                        label="Título do Relatório"
                        variant="outlined"
                        margin="normal"
                        helperText="Se deixar vazio, o relatório será salvo como 'sem título'."
                        value={relatorio?.nome || ''}
                        onChange={(e) => setRelatorio((prevState) => ({ ...prevState, nome: e.target.value }))}
                    />
                </section>

                <section className="tw-rounded-2xl tw-border tw-border-slate-200 tw-bg-white tw-p-4 md:tw-p-5">
                    <h3 className="tw-mb-4 tw-text-base tw-font-bold tw-text-slate-900">
                        Conteúdo do relatório
                    </h3>

                    <Editor
                        setEditorData={setRelatorio}
                        editorData={relatorio?.conteudo}
                    />
                </section>

                <section className="tw-rounded-2xl tw-border tw-border-slate-200 tw-bg-white tw-p-4 md:tw-p-5">
                    <h3 className="tw-mb-1 tw-text-base tw-font-bold tw-text-slate-900">
                        Anexo obrigatório
                    </h3>
                    <p className="tw-mb-4 tw-text-sm tw-leading-6 tw-text-slate-600">
                        Anexe o ficheiro PDF do relatório. O envio só será liberado após selecionar um anexo válido.
                    </p>

                    <InputDocUpload
                        imputLigth={true}
                        fullWidth={true}
                        onFileSelect={HandleChangeFile}
                        inputName={'anexoRelatorio'}
                        inputDescription={'Anexo em PDF do relatório'}
                        inputTitle={'Adicionar anexo'}
                    />

                    {selectedFileName && (
                        <p className="tw-mt-2 tw-text-sm tw-font-medium tw-text-emerald-600">
                            Anexo selecionado: {selectedFileName}
                        </p>
                    )}
                </section>

                <ButtonLeft
                    title={'Salvar Relatório'}
                    disabled={!canSubmit}
                    funcao={sendRelatorio}
                    load={open}
                >
                    <button
                        type="button"
                        onClick={handleClose}
                        disabled={open}
                        className="tw-inline-flex tw-items-center tw-rounded-lg tw-border tw-border-rose-200 tw-bg-rose-50 tw-px-4 tw-py-2 tw-text-sm tw-font-semibold tw-text-rose-700 tw-transition hover:tw-bg-rose-100 disabled:tw-cursor-not-allowed disabled:tw-opacity-60"
                    >
                        Cancelar
                    </button>
                </ButtonLeft>
            </div>
        </>
    )
}